module.exports = __webpack_public_path__ + "img/logo_nobi.cb407a09.png";